import React, { memo } from 'react';
import PropTypes from 'prop-types';

function Applications({ applications }) {
  function handleOnClick({ app }) {
    window.open(`/MyApps/Redirect?app=${app}`, '_blank', 'noopener,noreferrer');
  }

  return (
    <ul data-testid="applications">
      {applications?.map((app) => (
        <li key={app.appName}>
          <button
            type="button"
            data-testid={`app-${app.app}`}
            onClick={() => handleOnClick(app)}
          >
            {app.appName}
          </button>
        </li>
      ))}
    </ul>
  );
}

Applications.propTypes = {
  applications: PropTypes.array.isRequired
};

export default memo(Applications);
